<template>
  <el-dialog title="编辑采购价格"
             :visible.sync="visible"
             width="560px"
             @closed='handleClose'
             :close-on-press-escape="false"
             append-to-body>
    <el-form status-icon
             :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="110px">
      <el-form-item label="最小采购量:"
                    prop="minNum">
        <el-input-number v-model="ruleForm.minNum"
                         disabled
                         :precision="0"></el-input-number>
        <span style="margin-left: 5px">万枚</span>
      </el-form-item>
      <el-form-item label="最大采购量:"
                    prop="maxNum">
        <el-input-number v-model="ruleForm.maxNum"
                         :min="ruleForm.minNum"
                         :disabled="options.index > -1"
                         :precision="0"></el-input-number>
        <span style="margin-left: 5px">万枚</span>
      </el-form-item>
      <el-form-item label="采购单价:"
                    prop="unitPrice">
        <el-input-number v-model="ruleForm.unitPrice"
                         :min="0.0001"
                         :precision="4"
                         :max="1000"></el-input-number>
        <span style="margin-left: 5px">元/枚</span>
      </el-form-item>
      <el-form-item label="采购价:"
                    prop="otherFees">
        <el-table border
                  :data="ruleForm.otherFees">
          <el-table-column label="费用名称"
                           min-width="120"
                           prop="feeName">
            <template slot-scope="{ row }">
              <el-input v-model="row.feeName"
                        :maxlength="6"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="费用"
                           min-width="100"
                           prop="fee">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.fee"
                               :min="0"
                               :max="100000"
                               :precision="2"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="60">
            <template slot-scope="{ $index }">
              <el-button type="text"
                         @click="deleteFee($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="addFee"
                 type="primary"
                 :loading="loading">添加其他费用</el-button>
      <el-button @click="visible = false"
                 :loading="loading">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">提 交</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'purchase-product-price-edit-modal',
  data () {
    return {
      loading: false,
      visible: false,
      options: { index: -1 },
      ruleForm: { minNum: 1, maxNum: undefined, unitPrice: undefined, otherFees: [] },
      rules: {
        minNum: [ { required: true, message: '请输入最小采购量', trigger: 'blur' } ],
        maxNum: [ { required: true, message: '请输入最大采购量', trigger: 'blur' } ],
        unitPrice: [ { required: true, message: '请输入采购单价', trigger: 'blur' } ],
        otherFees: [ { required: false, message: '请填写其他费用', trigger: 'change', type: 'array' } ]
      }
    }
  },
  methods: {
    handleClose () {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    init (row = {}, options = {}) {
      this.visible = true
      this.ruleForm = { ...this.ruleForm, ...row }
      this.options = { ...this.options, ...options }
    },
    addFee () {
      this.ruleForm.otherFees.push({ feeName: '', fee: undefined })
    },
    deleteFee (index) {
      this.ruleForm.otherFees.splice(index, 1)
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const { otherFees } = this.ruleForm
          if (otherFees.some(i => !i.feeName || i.fee == null)) {
            this.$message.error('请填写完整其他费用')
            return
          }
          this.$emit('update', { ...this.ruleForm }, this.options.index)
          this.visible = false
        }
      })
    }
  }
}
</script>
